import React, { createContext, useState, useContext } from 'react';

// Contexte pour la langue
const LanguageContext = createContext();

// Les langues disponibles avec une gestion complète des catégories
const languages = {
  fr: {
    name: 'Français',
    flag: 'france.png',
    code: 'fr',
    accueil: 'ACCUEIL',
    apropos: 'À PROPOS',
    appstore: 'APP STORE',
    googleplay: 'GOOGLE PLAY',
    slogan: 'JOUEZ. DÉFIEZ. GAGNEZ.',
    themes: 'THÈMES',
    droitsReserves: 'Tous droits réservés.',
    social: 'RÉSEAUX SOCIAUX',
    download: 'TÉLÉCHARGEMENT',
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: 'Conditions d\'utilisation',
    contact: 'Contact',
    cgu: 'CGU',
    cguTitle: 'Conditions Générales d\'Utilisation',
    cguIntro: 'Bienvenue sur Quizzer. En utilisant notre application et nos services, vous acceptez de vous conformer aux présentes conditions générales d\'utilisation.',
    cguSection1Title: '1. Acceptation des Conditions',
    cguSection1Content: 'En accédant à l\'application Quizzer, vous acceptez d\'être lié par ces conditions d\'utilisation, toutes les lois et réglementations applicables, et vous acceptez que vous êtes responsable du respect des lois locales applicables. Si vous n\'acceptez pas l\'une de ces conditions, vous êtes interdit d\'utiliser ou d\'accéder à cette application.',
    cguSection2Title: '2. Licence d\'utilisation',
    cguSection2Content: 'L\'autorisation est accordée de télécharger temporairement une copie de l\'application Quizzer pour un usage personnel, non commercial transitoire uniquement. Il s\'agit de l\'octroi d\'une licence, et non d\'un transfert de titre, et sous cette licence, vous ne pouvez pas :',
    cguSection2Item1: 'Modifier ou copier le contenu de l\'application;',
    cguSection2Item2: 'Utiliser le contenu à des fins commerciales;',
    cguSection2Item3: 'Tenter de décompiler ou de désosser tout logiciel contenu dans l\'application;',
    cguSection2Item4: 'Supprimer tout droit d\'auteur ou autres notations de propriété des contenus;',
    cguSection2Item5: 'Transférer le contenu à une autre personne ou "dupliquer" le contenu sur un autre serveur.',
    cguSection3Title: '3. Exactitude des contenus',
    cguSection3Content: 'Les contenus de l\'application Quizzer sont fournis à titre informatif et divertissant uniquement. Bien que nous nous efforcions de maintenir l\'exactitude des informations, nous ne garantissons pas que le contenu soit exact, complet, fiable, à jour ou sans erreurs.',
    cguSection4Title: '4. Droits de propriété intellectuelle',
    cguSection4Content: 'Tous les contenus présents ou rendus disponibles à travers l\'application Quizzer - texte, graphiques, logos, images, ainsi que leur compilation - sont la propriété de Quizzer ou de ses fournisseurs de contenu et sont protégés par les lois sur la propriété intellectuelle.',
    cguSection5Title: '5. Utilisation des données',
    cguSection5Content: 'Quizzer collecte et utilise vos données conformément à notre Politique de Confidentialité. En utilisant notre application, vous consentez à cette collecte et utilisation de vos données.',
    cguSection6Title: '6. Comptes utilisateurs',
    cguSection6Content: 'Lorsque vous créez un compte sur Quizzer, vous êtes responsable de maintenir la confidentialité de votre compte et mot de passe et de restreindre l\'accès à votre ordinateur. Vous acceptez d\'assumer la responsabilité de toutes les activités qui se produisent sous votre compte ou mot de passe.',
    cguSection7Title: '7. Modifications des conditions',
    cguSection7Content: 'Quizzer peut réviser ces conditions d\'utilisation à tout moment sans préavis. En utilisant cette application, vous acceptez d\'être lié par la version alors actuelle de ces termes et conditions.',
    cguSection8Title: '8. Loi applicable',
    cguSection8Content: 'Ces conditions sont régies et interprétées conformément aux lois françaises, et vous vous soumettez irrévocablement à la juridiction exclusive des tribunaux de cette juridiction.',
    cguSection9Title: '9. Contact',
    cguSection9Content: 'Pour toute question concernant ces conditions d\'utilisation, veuillez nous contacter via notre page de contact.',
    // Nouvelles clés pour le composant Presentation
    interfaceIntuitive: 'DES QUIZ POUR TOUS',
    presentationDescription: 'Affrontez des joueurs du monde entier, grimpez dans les classements et testez vos connaissances sur + de 100 thèmes.',
    presentationSubtitle: 'Une expérience fluide et immersive, des défis palpitants et un profil personnalisable.',
    presentationMaster: 'MONTREZ QUI EST LE MAÎTRE.',
    featureSearch: 'Affrontez d\'autres joueurs en duel',
    featureRank: 'Partagez vos exploits',
    featureProgress: 'Personnalisez votre profil',
    featurePersonalize: 'Interface fluide et immersive',
    featureMode: 'Progressez dans les classements',
    // Nouvelles clés pour le composant Stats
    'QUESTIONS': 'QUESTIONS',
    'PARTIES JOUÉES': 'PARTIES JOUÉES',
    'NOTE MOYENNE': 'NOTE MOYENNE',
    'statsQuestionsDesc': 'Un défi pour tous les passionnés de quiz.',
    'statsGamesDesc': 'Des milliers de joueurs s\'affrontent chaque jour. Rejoignez la bataille.',
    'statsRatingDesc': 'Approuvé par une communauté de joueurs conquis.',
    // Nouvelles clés pour le composant FAQ
    'FAQ': 'FAQ',
    'faqHowToPlay': 'Comment jouer à Quizzer ?',
    'faqHowToPlayAnswer': 'Il vous suffit de télécharger l\'application, de créer un compte et de commencer à jouer. Vous pouvez affronter d\'autres joueurs en duel ou tester vos connaissances en solo.',
    'faqIsFree': 'L\'application est-elle gratuite ?',
    'faqIsFreeAnswer': 'Oui, Quizzer est 100% gratuit. Vous pouvez jouer sans limite, mais certaines fonctionnalités premium sont disponibles via des achats intégrés ou un abonnement.',
    'faqPlayWithFriends': 'Puis-je jouer avec mes amis ?',
    'faqPlayWithFriendsAnswer': 'Bien sûr ! Vous pouvez défier vos amis directement depuis l\'application et comparer vos scores.',
    'faqNewContent': 'L\'application sera-t-elle mise à jour avec de nouveaux contenus ?',
    'faqNewContentAnswer': 'Absolument ! Notre équipe travaille constamment pour ajouter de nouvelles questions, catégories et fonctionnalités. Restez à l\'affût des mises à jour régulières.',
    // Nouvelles clés pour la page "À propos"
    aboutIntro: 'Découvrez Quizzer, l\'application de quiz qui révolutionne votre façon d\'apprendre tout en vous amusant.',
    aboutMissionTitle: 'Notre Mission',
    aboutMissionDesc: 'Rendre l\'apprentissage ludique et accessible à tous grâce à une plateforme de quiz innovante et engageante.',
    aboutInnovationTitle: 'Innovation',
    aboutInnovationDesc: 'Nous repoussons constamment les limites de la technologie pour offrir une expérience de jeu immersive et captivante.',
    aboutQualityTitle: 'Qualité',
    aboutQualityDesc: 'Chaque question est soigneusement élaborée et vérifiée pour garantir un contenu précis et enrichissant.',
    aboutVisionTitle: 'Notre Vision',
    aboutVisionDesc: 'Nous aspirons à créer la communauté de quiz la plus dynamique et la plus diversifiée au monde, où les joueurs peuvent se défier, apprendre et grandir ensemble.',
    aboutTeamTitle: 'Notre Équipe',
    aboutTeamRole1: 'Fondateur & CEO',
    aboutTeamRole2: 'Directrice Créative',
    aboutTeamRole3: 'Développeur Principal',
    aboutTeamRole4: 'Responsable Marketing',
    aboutFounder: 'Le Fondateur',
    aboutFounderDesc: 'Baptiste Kabel a créé Quizzer avec une passion pour l\'apprentissage interactif et le jeu. Après avoir constaté le manque d\'applications de quiz véritablement engageantes, il a décidé de développer une solution qui rend l\'acquisition de connaissances amusante et addictive.',
    joinTeamTitle: 'Rejoignez l\'Aventure',
    joinTeamDesc: 'Quizzer est en pleine croissance et nous cherchons des talents passionnés pour nous aider à développer la meilleure application de quiz au monde. Si vous êtes motivé, créatif et que vous aimez les défis, nous serions ravis d\'échanger avec vous.',
    joinTeamButton: 'NOUS CONTACTER',
    // Traductions des catégories - format corrigé
    'Africa Cultural': 'Afrique Culturelle',
    'Afrobeats Modern': 'Afrobeats Moderne',
    'America Latina': 'Amérique Latine',
    'Anatomie': 'Anatomie',
    'Animal Crossing': 'Animal Crossing',
    'Animals': 'Animaux',
    'Antiquity': 'Antiquité',
    'Aot': 'Attack on Titan',
    'Archipel Island': 'Îles de l\'Archipel',
    'Arsenal Fc': 'Arsenal FC',
    'Artistic Movement': 'Mouvement Artistique',
    'Asiatic Cultural': 'Culture Asiatique',
    'Assassins Creed': 'Assassin\'s Creed',
    'Astronomie': 'Astronomie',
    'Athletism': 'Athlétisme',
    'Attentats And Crises': 'Attentats et Crises',
    'Batman': 'Batman',
    'Big Realisator': 'Grands Réalisateurs',
    'Paris Saint Germain': 'Paris Saint-Germain',
    'Peaky Blinders': 'Peaky Blinders',
    'Peintres': 'Peintres',
    'Peter Pan': 'Peter Pan',
    'Plants': 'Plantes',
    'Poetes': 'Poètes',
    'Pop': 'Pop',
    'Power': 'Power',
    'Pre History': 'Préhistoire',
    'Premier League': 'Premier League',
    'Prison Break': 'Prison Break',
    'Programmation': 'Programmation',
    'Psycho Pass': 'Psycho-Pass',
    'Rap Fr Modern': 'Rap Français Moderne',
    'Rap Us Modern': 'Rap US Moderne',
    'Reggae': 'Reggae',
    'Retour Vers Le Futur': 'Retour vers le Futur',
    'Revolution And Empire': 'Révolution et Empire',
    'Rnb': 'R&B',
    'Rock': 'Rock',
    'Rolland Garros': 'Roland-Garros',
    'Rugby': 'Rugby',
    'Savoir Faire Traditional': 'Savoir-faire Traditionnel',
    'Scientific Discovery': 'Découvertes Scientifiques',
    // Nouvelles clés pour la page Blog
    blogIntro: "Bienvenue sur le blog de Quizzer, votre source d'informations sur les quiz, l'apprentissage et les nouveautés de notre plateforme.",
    featured: "À la une",
    readMore: "Lire la suite",
    backToArticles: "Retour aux articles",
    shareArticle: "Partager cet article :",
    // Nouvelles clés pour la page Contact
    contactTitle: "Contactez-nous",
    contactIntro: "Vous avez des questions, des suggestions ou vous souhaitez collaborer avec nous ? N'hésitez pas à nous contacter via ce formulaire.",
    contactName: "Votre nom",
    contactEmail: "Votre email",
    contactSubject: "Sujet",
    contactMessage: "Votre message",
    contactSend: "Envoyer",
    contactSuccess: "Votre message a été envoyé avec succès !",
    contactError: "Une erreur s'est produite. Veuillez réessayer.",
    contactSubjectSuggestion: "Suggestion",
    contactSubjectCategory: "Nouvelle catégorie",
    contactSubjectBug: "Signaler un bug",
    contactSubjectOther: "Autre",
    // Ajout des versions camelCase pour correspondre aux noms de fichiers
    'AfricaCultural': 'Afrique Culturelle',
    'AfrobeatsModern': 'Afrobeats Moderne',
    'AmericaLatina': 'Amérique Latine',
    'AnimalCrossing': 'Animal Crossing',
    'ArchipelIsland': 'Îles de l\'Archipel',
    'ArsenalFc': 'Arsenal FC',
    'ArtisticMovement': 'Mouvement Artistique',
    'AsiaticCultural': 'Culture Asiatique',
    'AssassinsCreed': 'Assassin\'s Creed',
    'AttentatsAndCrises': 'Attentats et Crises',
    'BigRealisator': 'Grands Réalisateurs',
    'ParisSaintGermain': 'Paris Saint-Germain',
    'PeakyBlinders': 'Peaky Blinders',
    'PeterPan': 'Peter Pan',
    'PreHistory': 'Préhistoire',
    'PremierLeague': 'Premier League',
    'PrisonBreak': 'Prison Break',
    'PsychoPass': 'Psycho-Pass',
    'RapFrModern': 'Rap Français Moderne',
    'RapUsModern': 'Rap US Moderne',
    'RetourVersLeFutur': 'Retour vers le Futur',
    'RevolutionAndEmpire': 'Révolution et Empire',
    'RollandGarros': 'Roland-Garros',
    'SavoirFaireTraditional': 'Savoir-faire Traditionnel',
    'ScientificDiscovery': 'Découvertes Scientifiques',
    eula: 'Conditions d\'Utilisation',
    eulaTitle: 'Conditions d\'Utilisation de Quizzer',
    eulaIntro: 'Bienvenue sur Quizzer. En utilisant notre application, vous acceptez les présentes conditions d\'utilisation.',
    eulaSection1Title: '1. Acceptation des Conditions',
    eulaSection1Content: 'En accédant à l\'application Quizzer, vous acceptez d\'être lié par ces conditions d\'utilisation, toutes les lois et réglementations applicables, et vous acceptez que vous êtes responsable du respect des lois locales applicables.',
    eulaSection2Title: '2. Licence d\'utilisation',
    eulaSection2Content: 'L\'autorisation est accordée de télécharger temporairement une copie de l\'application Quizzer pour un usage personnel, non commercial transitoire uniquement.',
    eulaSection3Title: '3. Propriété Intellectuelle',
    eulaSection3Content: 'Tous les contenus présents dans l\'application Quizzer sont la propriété de Quizzer ou de ses fournisseurs de contenu et sont protégés par les lois sur la propriété intellectuelle.',
    eulaSection4Title: '4. Utilisation des Données',
    eulaSection4Content: 'Quizzer collecte et utilise vos données conformément à notre Politique de Confidentialité.',
    eulaSection5Title: '5. Modifications',
    eulaSection5Content: 'Quizzer peut réviser ces conditions d\'utilisation à tout moment sans préavis.',
    privacySection1: '1. Introduction',
    privacySection1Text: 'Bienvenue dans notre Politique de Confidentialité. Quizzer respecte votre vie privée et s\'engage à protéger vos données personnelles. Cette politique de confidentialité vous informera sur la façon dont nous prenons soin de vos données personnelles lorsque vous visitez notre application et vous informera de vos droits en matière de confidentialité et de la manière dont la loi vous protège.',
    privacySection2: '2. Les données que nous collectons',
    privacySection2Text: 'Nous pouvons collecter, utiliser, stocker et transférer différents types de données personnelles vous concernant, notamment :\n\n• Données d\'identité : prénom, nom de famille, nom d\'utilisateur ou identifiant similaire\n• Données de contact : adresse e-mail\n• Données d\'utilisation : informations sur la façon dont vous utilisez notre application',
    privacySection3: '3. Comment nous utilisons vos données',
    privacySection3Text: 'Nous utilisons vos données pour les finalités suivantes :\n\n• Pour gérer votre compte et vous fournir nos services\n• Pour améliorer notre application et maintenir sa sécurité\n• Pour vous fournir des fonctionnalités personnalisées et des recommandations basées sur vos préférences\n• Pour vous envoyer des notifications et des mises à jour concernant votre activité',
    privacySection4: '4. Sécurité des données',
    privacySection4Text: 'Nous avons mis en place des mesures de sécurité appropriées pour empêcher que vos données personnelles ne soient accidentellement perdues, utilisées ou consultées de manière non autorisée, modifiées ou divulguées.',
    privacySection5: '5. Conservation des données',
    privacySection5Text: 'Nous ne conserverons vos données personnelles que le temps nécessaire pour atteindre les objectifs pour lesquels nous les avons collectées, y compris à des fins juridiques, comptables ou de reporting.',
    privacySection6: '6. Vos droits légaux',
    privacySection6Text: 'Selon les lois applicables en matière de protection des données, vous pouvez avoir des droits concernant vos données personnelles, notamment le droit d\'accès, de rectification, d\'effacement, d\'opposition au traitement, de limitation du traitement, de portabilité des données et de retrait du consentement.',
    privacySection7: '7. Modifications de notre politique de confidentialité',
    privacySection7Text: 'Nous publierons toute modification de notre politique de confidentialité sur cette page. Si les modifications sont importantes, nous vous en informerons par e-mail ou par notification dans l\'application.',
    privacySection8: '8. Contact',
    privacySection8Text: 'Si vous avez des questions concernant cette politique de confidentialité ou si vous souhaitez exercer l\'un de vos droits légaux, veuillez nous contacter via notre page de contact.',
    lastUpdated: 'Dernière mise à jour',
    allRightsReserved: 'Tous droits réservés'
  },
  en: {
    name: 'English',
    flag: 'uk.png',
    code: 'en',
    accueil: 'HOME',
    apropos: 'ABOUT',
    appstore: 'APP STORE',
    googleplay: 'GOOGLE PLAY',
    slogan: 'PLAY. CHALLENGE. CONQUER.',
    themes: 'THEMES',
    droitsReserves: 'All rights reserved.',
    social: 'SOCIAL MEDIA',
    download: 'DOWNLOAD',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    contact: 'Contact',
    cgu: 'T&C',
    cguTitle: 'Terms and Conditions',
    cguIntro: 'Welcome to Quizzer. By using our application and services, you agree to comply with these terms and conditions.',
    cguSection1Title: '1. Acceptance of Terms',
    cguSection1Content: 'By accessing the Quizzer application, you agree to be bound by these terms of use, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this application.',
    cguSection2Title: '2. Use License',
    cguSection2Content: 'Permission is granted to temporarily download one copy of the Quizzer application for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:',
    cguSection2Item1: 'Modify or copy the application content;',
    cguSection2Item2: 'Use the content for any commercial purpose;',
    cguSection2Item3: 'Attempt to decompile or reverse engineer any software contained in the application;',
    cguSection2Item4: 'Remove any copyright or other proprietary notations from the content;',
    cguSection2Item5: 'Transfer the content to another person or "mirror" the content on any other server.',
    cguSection3Title: '3. Content Accuracy',
    cguSection3Content: 'The content of the Quizzer application is provided for informational and entertainment purposes only. While we strive to maintain the accuracy of the information, we do not guarantee that the content is accurate, complete, reliable, current, or error-free.',
    cguSection4Title: '4. Intellectual Property Rights',
    cguSection4Content: 'All content present or made available through the Quizzer application - text, graphics, logos, images, as well as their compilation - is the property of Quizzer or its content providers and is protected by intellectual property laws.',
    cguSection5Title: '5. Data Usage',
    cguSection5Content: 'Quizzer collects and uses your data in accordance with our Privacy Policy. By using our application, you consent to this collection and use of your data.',
    cguSection6Title: '6. User Accounts',
    cguSection6Content: 'When you create an account on Quizzer, you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer. You agree to accept responsibility for all activities that occur under your account or password.',
    cguSection7Title: '7. Modifications to Terms',
    cguSection7Content: 'Quizzer may revise these terms of use at any time without notice. By using this application, you agree to be bound by the then current version of these terms and conditions.',
    cguSection8Title: '8. Governing Law',
    cguSection8Content: 'These terms are governed and construed in accordance with French laws, and you irrevocably submit to the exclusive jurisdiction of the courts in that jurisdiction.',
    cguSection9Title: '9. Contact',
    cguSection9Content: 'For any questions regarding these terms of use, please contact us through our contact page.',
    // New keys for Presentation component
    interfaceIntuitive: 'QUIZZES FOR EVERYONE',
    presentationDescription: 'Challenge players from around the world, climb the rankings and test your knowledge on over 100 themes.',
    presentationSubtitle: 'A fluid and immersive experience, thrilling challenges and a customizable profile.',
    presentationMaster: 'SHOW WHO IS THE MASTER.',
    featureSearch: 'Challenge other players in duels',
    featureRank: 'Share your achievements',
    featureProgress: 'Customize your profile',
    featurePersonalize: 'Fluid and immersive interface',
    featureMode: 'Progress in the rankings',
    // New keys for Stats component
    'QUESTIONS': 'QUESTIONS',
    'PARTIES JOUÉES': 'GAMES PLAYED',
    'NOTE MOYENNE': 'AVERAGE RATING',
    'statsQuestionsDesc': 'A challenge for all quiz enthusiasts.',
    'statsGamesDesc': 'Thousands of players compete every day. Join the battle.',
    'statsRatingDesc': 'Approved by a community of satisfied players.',
    // New keys for FAQ component
    'FAQ': 'FAQ',
    'faqHowToPlay': 'How to play Quizzer?',
    'faqHowToPlayAnswer': 'Simply download the app, create an account and start playing. You can challenge other players in duels or test your knowledge in solo mode.',
    'faqIsFree': 'Is the app free?',
    'faqIsFreeAnswer': 'Yes, Quizzer is 100% free. You can play without limits, but some premium features are available through in-app purchases or subscription.',
    'faqPlayWithFriends': 'Can I play with my friends?',
    'faqPlayWithFriendsAnswer': 'Absolutely! You can challenge your friends directly from the app and compare your scores.',
    'faqNewContent': 'Will the app be updated with new content?',
    'faqNewContentAnswer': 'Definitely! Our team is constantly working to add new questions, categories, and features. Stay tuned for regular updates.',
    // New keys for About page
    aboutIntro: 'Discover Quizzer, the quiz app that revolutionizes the way you learn while having fun.',
    aboutMissionTitle: 'Our Mission',
    aboutMissionDesc: 'Make learning fun and accessible to everyone through an innovative and engaging quiz platform.',
    aboutInnovationTitle: 'Innovation',
    aboutInnovationDesc: 'We constantly push the boundaries of technology to offer an immersive and captivating gaming experience.',
    aboutQualityTitle: 'Quality',
    aboutQualityDesc: 'Each question is carefully crafted and verified to ensure accurate and enriching content.',
    aboutVisionTitle: 'Our Vision',
    aboutVisionDesc: 'We aspire to create the most dynamic and diverse quiz community in the world, where players can challenge themselves, learn and grow together.',
    aboutTeamTitle: 'Our Team',
    aboutTeamRole1: 'Founder & CEO',
    aboutTeamRole2: 'Creative Director',
    aboutTeamRole3: 'Lead Developer',
    aboutTeamRole4: 'Marketing Manager',
    aboutFounder: 'The Founder',
    aboutFounderDesc: 'Baptiste Kabel created Quizzer with a passion for interactive learning and gaming. After noticing the lack of truly engaging quiz apps, he decided to develop a solution that makes acquiring knowledge fun and addictive.',
    joinTeamTitle: 'Join the Adventure',
    joinTeamDesc: 'Quizzer is growing and we are looking for passionate talents to help us develop the best quiz app in the world. If you are motivated, creative and enjoy challenges, we would be thrilled to exchange with you.',
    joinTeamButton: 'CONTACT US',
    // Translations for categories - format corrigé
    'Africa Cultural': 'African Culture',
    'Afrobeats Modern': 'Modern Afrobeats',
    'America Latina': 'Latin America',
    'Anatomie': 'Anatomy',
    'Animal Crossing': 'Animal Crossing',
    'Animals': 'Animals',
    'Antiquity': 'Antiquity',
    'Aot': 'Attack on Titan',
    'Archipel Island': 'Archipelago Islands',
    'Arsenal Fc': 'Arsenal FC',
    'Artistic Movement': 'Artistic Movement',
    'Asiatic Cultural': 'Asian Culture',
    'Assassins Creed': 'Assassin\'s Creed',
    'Astronomie': 'Astronomy',
    'Athletism': 'Athletics',
    'Attentats And Crises': 'Attacks and Crises',
    'Batman': 'Batman',
    'Big Realisator': 'Great Directors',
    'Paris Saint Germain': 'Paris Saint-Germain',
    'Peaky Blinders': 'Peaky Blinders',
    'Peintres': 'Painters',
    'Peter Pan': 'Peter Pan',
    'Plants': 'Plants',
    'Poetes': 'Poets',
    'Pop': 'Pop',
    'Power': 'Power',
    'Pre History': 'Prehistory',
    'Premier League': 'Premier League',
    'Prison Break': 'Prison Break',
    'Programmation': 'Programming',
    'Psycho Pass': 'Psycho-Pass',
    'Rap Fr Modern': 'Modern French Rap',
    'Rap Us Modern': 'Modern US Rap',
    'Reggae': 'Reggae',
    'Retour Vers Le Futur': 'Back to the Future',
    'Revolution And Empire': 'Revolution and Empire',
    'Rnb': 'R&B',
    'Rock': 'Rock',
    'Rolland Garros': 'Roland Garros',
    'Rugby': 'Rugby',
    'Savoir Faire Traditional': 'Traditional Know-how',
    'Scientific Discovery': 'Scientific Discoveries',
    'Series': 'TV Shows',
    // Nouvelles clés pour la page Blog
    blogIntro: "Welcome to the Quizzer blog, your source of information about quizzes, learning, and updates about our platform.",
    featured: "Featured",
    readMore: "Read more",
    backToArticles: "Back to articles",
    shareArticle: "Share this article:",
    // Nouvelles clés pour la page Contact
    contactTitle: "Contact Us",
    contactIntro: "Do you have questions, suggestions, or would you like to collaborate with us? Feel free to contact us using this form.",
    contactName: "Your name",
    contactEmail: "Your email",
    contactSubject: "Subject",
    contactMessage: "Your message",
    contactSend: "Send",
    contactSuccess: "Your message has been sent successfully!",
    contactError: "An error occurred. Please try again.",
    contactSubjectSuggestion: "Suggestion",
    contactSubjectCategory: "New category",
    contactSubjectBug: "Report a bug",
    contactSubjectOther: "Other",
    // Ajout des versions camelCase pour correspondre aux noms de fichiers
    'AfricaCultural': 'African Culture',
    'AfrobeatsModern': 'Modern Afrobeats',
    'AmericaLatina': 'Latin America',
    'AnimalCrossing': 'Animal Crossing',
    'ArchipelIsland': 'Archipelago Islands',
    'ArsenalFc': 'Arsenal FC',
    'ArtisticMovement': 'Artistic Movement',
    'AsiaticCultural': 'Asian Culture',
    'AssassinsCreed': 'Assassin\'s Creed',
    'AttentatsAndCrises': 'Attacks and Crises',
    'BigRealisator': 'Great Directors',
    'ParisSaintGermain': 'Paris Saint-Germain',
    'PeakyBlinders': 'Peaky Blinders',
    'PeterPan': 'Peter Pan',
    'PreHistory': 'Prehistory',
    'PremierLeague': 'Premier League',
    'PrisonBreak': 'Prison Break',
    'PsychoPass': 'Psycho-Pass',
    'RapFrModern': 'Modern French Rap',
    'RapUsModern': 'Modern US Rap',
    'RetourVersLeFutur': 'Back to the Future',
    'RevolutionAndEmpire': 'Revolution and Empire',
    'RollandGarros': 'Roland Garros',
    'SavoirFaireTraditional': 'Traditional Know-how',
    'ScientificDiscovery': 'Scientific Discoveries',
    eula: 'Terms of Use',
    eulaTitle: 'Quizzer Terms of Use',
    eulaIntro: 'Welcome to Quizzer. By using our application, you agree to these terms of use.',
    eulaSection1Title: '1. Acceptance of Terms',
    eulaSection1Content: 'By accessing the Quizzer application, you agree to be bound by these terms of use, all applicable laws and regulations, and you agree that you are responsible for compliance with any applicable local laws.',
    eulaSection2Title: '2. Use License',
    eulaSection2Content: 'Permission is granted to temporarily download one copy of the Quizzer application for personal, non-commercial transitory viewing only.',
    eulaSection3Title: '3. Intellectual Property',
    eulaSection3Content: 'All content present in the Quizzer application is the property of Quizzer or its content providers and is protected by intellectual property laws.',
    eulaSection4Title: '4. Data Usage',
    eulaSection4Content: 'Quizzer collects and uses your data in accordance with our Privacy Policy.',
    eulaSection5Title: '5. Modifications',
    eulaSection5Content: 'Quizzer may revise these terms of use at any time without notice.',
    privacySection1: '1. Introduction',
    privacySection1Text: 'Welcome to our Privacy Policy. Quizzer respects your privacy and is committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data when you visit our application and tell you about your privacy rights and how the law protects you.',
    privacySection2: '2. The Data We Collect',
    privacySection2Text: 'We may collect, use, store and transfer different kinds of personal data about you, including:\n\n• Identity Data: first name, last name, username or similar identifier\n• Contact Data: email address\n• Usage Data: information about how you use our application',
    privacySection3: '3. How We Use Your Data',
    privacySection3Text: 'We use your data for the following purposes:\n\n• To manage your account and provide you with our services\n• To improve our application and maintain its security\n• To provide you with personalized features and recommendations based on your preferences\n• To send you notifications and updates about your activity',
    privacySection4: '4. Data Security',
    privacySection4Text: 'We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed.',
    privacySection5: '5. Data Retention',
    privacySection5Text: 'We will only retain your personal data for as long as necessary to fulfill the purposes we collected it for, including for legal, accounting, or reporting requirements.',
    privacySection6: '6. Your Legal Rights',
    privacySection6Text: 'Under applicable data protection laws, you may have rights regarding your personal data, including the right to access, correct, delete, object to processing, restrict processing, data portability, and withdraw consent.',
    privacySection7: '7. Changes to Our Privacy Policy',
    privacySection7Text: 'We will post any changes to our privacy policy on this page. If the changes are significant, we will notify you by email or through a notification in the application.',
    privacySection8: '8. Contact',
    privacySection8Text: 'If you have any questions about this privacy policy or wish to exercise any of your legal rights, please contact us through our contact page.',
    lastUpdated: 'Last updated',
    allRightsReserved: 'All rights reserved'
  },
  es: {
    name: 'Español',
    flag: 'spain.png',
    code: 'es',
    accueil: 'INICIO',
    apropos: 'ACERCA DE',
    appstore: 'APP STORE',
    googleplay: 'GOOGLE PLAY',
    slogan: 'JUEGA. DESAFÍA. GANA.',
    themes: 'TEMAS',
    droitsReserves: 'Todos los derechos reservados.',
    social: 'REDES SOCIALES',
    download: 'DESCARGAR',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    contact: 'Contacto',
    cgu: 'T&C',
    cguTitle: 'Términos y Condiciones',
    cguIntro: 'Bienvenido a Quizzer. Al utilizar nuestra aplicación y servicios, usted acepta cumplir con estos términos y condiciones.',
    cguSection1Title: '1. Aceptación de las Condiciones',
    cguSection1Content: 'Al acceder a la aplicación Quizzer, acepta quedar vinculado por estos términos de uso, todas las leyes y regulaciones aplicables, y acepta que es responsable del cumplimiento de cualquier ley local aplicable. Si no está de acuerdo con alguno de estos términos, se le prohíbe usar o acceder a esta aplicación.',
    cguSection2Title: '2. Licencia de Uso',
    cguSection2Content: 'Se otorga permiso para descargar temporalmente una copia de la aplicación Quizzer únicamente para visualización personal y no comercial. Esta es la concesión de una licencia, no una transferencia de título, y bajo esta licencia no puede:',
    cguSection2Item1: 'Modificar o copiar el contenido de la aplicación;',
    cguSection2Item2: 'Utilizar el contenido con fines comerciales;',
    cguSection2Item3: 'Intentar descompilar o aplicar ingeniería inversa a cualquier software contenido en la aplicación;',
    cguSection2Item4: 'Eliminar cualquier copyright u otras notaciones de propiedad del contenido;',
    cguSection2Item5: 'Transferir el contenido a otra persona o "duplicar" el contenido en otro servidor.',
    cguSection3Title: '3. Exactitud del Contenido',
    cguSection3Content: 'El contenido de la aplicación Quizzer se proporciona únicamente con fines informativos y de entretenimiento. Aunque nos esforzamos por mantener la exactitud de la información, no garantizamos que el contenido sea preciso, completo, confiable, actual o libre de errores.',
    cguSection4Title: '4. Derechos de Propiedad Intelectual',
    cguSection4Content: 'Todo el contenido presente o disponible a través de la aplicación Quizzer - texto, gráficos, logotipos, imágenes, así como su compilación - es propiedad de Quizzer o de sus proveedores de contenido y está protegido por las leyes de propiedad intelectual.',
    cguSection5Title: '5. Uso de Datos',
    cguSection5Content: 'Quizzer recopila y utiliza sus datos de acuerdo con nuestra Política de Privacidad. Al usar nuestra aplicación, usted consiente esta recopilación y uso de sus datos.',
    cguSection6Title: '6. Cuentas de Usuario',
    cguSection6Content: 'Cuando crea una cuenta en Quizzer, es responsable de mantener la confidencialidad de su cuenta y contraseña, y de restringir el acceso a su computadora. Acepta asumir la responsabilidad de todas las actividades que ocurran bajo su cuenta o contraseña.',
    cguSection7Title: '7. Modificaciones a los Términos',
    cguSection7Content: 'Quizzer puede revisar estos términos de uso en cualquier momento sin previo aviso. Al usar esta aplicación, acepta estar vinculado por la versión actual de estos términos y condiciones.',
    cguSection8Title: '8. Ley Aplicable',
    cguSection8Content: 'Estos términos se rigen e interpretan de acuerdo con las leyes francesas, y usted se somete irrevocablemente a la jurisdicción exclusiva de los tribunales de esa jurisdicción.',
    cguSection9Title: '9. Contacto',
    cguSection9Content: 'Para cualquier pregunta sobre estos términos de uso, contáctenos a través de nuestra página de contacto.',
    // Nouvelles clés pour le composant Presentation
    interfaceIntuitive: 'CUESTIONARIOS PARA TODOS',
    presentationDescription: 'Desafía a jugadores de todo el mundo, sube en los rankings y pon a prueba tus conocimientos en más de 100 temas.',
    presentationSubtitle: 'Una experiencia fluida e inmersiva, desafíos emocionantes y un perfil personalizable.',
    presentationMaster: 'DEMUESTRA QUIÉN ES EL MAESTRO.',
    featureSearch: 'Desafía a otros jugadores en duelos',
    featureRank: 'Comparte tus logros',
    featureProgress: 'Personaliza tu perfil',
    featurePersonalize: 'Interfaz fluida e inmersiva',
    featureMode: 'Progresa en los rankings',
    // Nouvelles claves para el componente Stats
    'QUESTIONS': 'PREGUNTAS',
    'PARTIES JOUÉES': 'PARTIDAS JUGADAS',
    'NOTE MOYENNE': 'VALORACIÓN MEDIA',
    'statsQuestionsDesc': 'Un desafío para todos los entusiastas de los cuestionarios.',
    'statsGamesDesc': 'Miles de jugadores compiten cada día. Únete a la batalla.',
    'statsRatingDesc': 'Aprobado por una comunidad de jugadores satisfechos.',
    // Nuevas claves para el componente FAQ
    'FAQ': 'PREGUNTAS FRECUENTES',
    'faqHowToPlay': '¿Cómo jugar a Quizzer?',
    'faqHowToPlayAnswer': 'Simplemente descarga la aplicación, crea una cuenta y empieza a jugar. Puedes desafiar a otros jugadores en duelos o poner a prueba tus conocimientos en modo individual.',
    'faqIsFree': '¿Es gratuita la aplicación?',
    'faqIsFreeAnswer': 'Sí, Quizzer es 100% gratuito. Puedes jugar sin límites, pero algunas funciones premium están disponibles a través de compras dentro de la aplicación o suscripción.',
    'faqPlayWithFriends': '¿Puedo jugar con mis amigos?',
    'faqPlayWithFriendsAnswer': '¡Por supuesto! Puedes desafiar a tus amigos directamente desde la aplicación y comparar tus puntuaciones.',
    'faqNewContent': '¿Se actualizará la aplicación con nuevo contenido?',
    'faqNewContentAnswer': '¡Definitivamente! Nuestro equipo trabaja constantemente para añadir nuevas preguntas, categorías y funciones. Mantente atento a las actualizaciones regulares.',
    // Nuevas claves para la página "Acerca de"
    aboutIntro: 'Descubre Quizzer, la aplicación de cuestionarios que revoluciona la forma en que aprendes mientras te diviertes.',
    aboutMissionTitle: 'Nuestra Misión',
    aboutMissionDesc: 'Hacer que el aprendizaje sea divertido y accesible para todos a través de una plataforma de cuestionarios innovadora y atractiva.',
    aboutInnovationTitle: 'Innovación',
    aboutInnovationDesc: 'Constantemente superamos los límites de la tecnología para ofrecer una experiencia de juego inmersiva y cautivadora.',
    aboutQualityTitle: 'Calidad',
    aboutQualityDesc: 'Cada pregunta está cuidadosamente elaborada y verificada para garantizar un contenido preciso y enriquecedor.',
    aboutVisionTitle: 'Nuestra Visión',
    aboutVisionDesc: 'Aspiramos a crear la comunidad de cuestionarios más dinámica y diversa del mundo, donde los jugadores puedan desafiarse a sí mismos, aprender y crecer juntos.',
    aboutTeamTitle: 'Nuestro Equipo',
    aboutTeamRole1: 'Fundador y CEO',
    aboutTeamRole2: 'Directora Creativa',
    aboutTeamRole3: 'Desarrollador Principal',
    aboutTeamRole4: 'Responsable de Marketing',
    aboutFounder: 'El Fundador',
    aboutFounderDesc: 'Baptiste Kabel creó Quizzer con una pasión por el aprendizaje interactivo y el juego. Después de notar la falta de aplicaciones de cuestionarios realmente atractivas, decidió desarrollar una solución que hace que adquirir conocimientos sea divertido y adictivo.',
    joinTeamTitle: 'Únete a la Aventura',
    joinTeamDesc: 'Quizzer está creciendo y estamos buscando talentos apasionados para ayudarnos a desarrollar la mejor aplicación de cuestionarios del mundo. Si estás motivado, creativo y te gusta desafiar, nos encantaría intercambiar con vosotros.',
    joinTeamButton: 'CONTÁCTANOS',
    // Traducciones para categorías - format corrigé
    'Africa Cultural': 'África Cultural',
    'Afrobeats Modern': 'Afrobeats Moderno',
    'America Latina': 'América Latina',
    'Anatomie': 'Anatomía',
    'Animal Crossing': 'Animal Crossing',
    'Animals': 'Animales',
    'Antiquity': 'Antigüedad',
    'Aot': 'Attack on Titan',
    'Archipel Island': 'Islas del Archipiélago',
    'Arsenal Fc': 'Arsenal FC',
    'Artistic Movement': 'Movimientos Artísticos',
    'Asiatic Cultural': 'Cultura Asiática',
    'Assassins Creed': 'Assassin\'s Creed',
    'Astronomie': 'Astronomía',
    'Athletism': 'Atletismo',
    'Attentats And Crises': 'Atentados y Crisis',
    'Batman': 'Batman',
    'Big Realisator': 'Grandes Directores',
    'Paris Saint Germain': 'Paris Saint-Germain',
    'Peaky Blinders': 'Peaky Blinders',
    'Peintres': 'Pintores',
    'Peter Pan': 'Peter Pan',
    'Plants': 'Plantas',
    'Poetes': 'Poetas',
    'Pop': 'Pop',
    'Power': 'Power',
    'Pre History': 'Prehistoria',
    'Premier League': 'Premier League',
    'Prison Break': 'Prison Break',
    'Programmation': 'Programación',
    'Psycho Pass': 'Psycho-Pass',
    'Rap Fr Modern': 'Rap Francés Moderno',
    'Rap Us Modern': 'Rap Estadounidense Moderno',
    'Reggae': 'Reggae',
    'Retour Vers Le Futur': 'Regreso al Futuro',
    'Revolution And Empire': 'Revolución e Imperio',
    'Rnb': 'R&B',
    'Rock': 'Rock',
    'Rolland Garros': 'Roland Garros',
    'Rugby': 'Rugby',
    'Savoir Faire Traditional': 'Saber Hacer Tradicional',
    'Scientific Discovery': 'Descubrimientos Científicos',
    'Series': 'Series',
    // Nouvelles clés pour la page Blog
    blogIntro: "Bienvenido al blog de Quizzer, su fuente de información sobre cuestionarios, aprendizaje y actualizaciones sobre nuestra plataforma.",
    featured: "Destacado",
    readMore: "Leer más",
    backToArticles: "Volver a los artículos",
    shareArticle: "Compartir este artículo:",
    // Nuevas claves para la página de Contacto
    contactTitle: "Contáctanos",
    contactIntro: "¿Tienes preguntas, sugerencias o te gustaría colaborar con nosotros? No dudes en contactarnos a través de este formulario.",
    contactName: "Tu nombre",
    contactEmail: "Tu correo electrónico",
    contactSubject: "Asunto",
    contactMessage: "Tu mensaje",
    contactSend: "Enviar",
    contactSuccess: "¡Tu mensaje ha sido enviado con éxito!",
    contactError: "Se ha producido un error. Por favor, inténtalo de nuevo.",
    contactSubjectSuggestion: "Sugerencia",
    contactSubjectCategory: "Nueva categoría",
    contactSubjectBug: "Reportar un error",
    contactSubjectOther: "Otro",
    // Ajout des versions camelCase para coincidir con los nombres de archivo
    'AfricaCultural': 'África Cultural',
    'AfrobeatsModern': 'Afrobeats Moderno',
    'AmericaLatina': 'América Latina',
    'AnimalCrossing': 'Animal Crossing',
    'ArchipelIsland': 'Islas del Archipiélago',
    'ArsenalFc': 'Arsenal FC',
    'ArtisticMovement': 'Movimientos Artísticos',
    'AsiaticCultural': 'Cultura Asiática',
    'AssassinsCreed': 'Assassin\'s Creed',
    'AttentatsAndCrises': 'Atentados y Crisis',
    'BigRealisator': 'Grandes Directores',
    'ParisSaintGermain': 'Paris Saint-Germain',
    'PeakyBlinders': 'Peaky Blinders',
    'PeterPan': 'Peter Pan',
    'PreHistory': 'Prehistoria',
    'PremierLeague': 'Premier League',
    'PrisonBreak': 'Prison Break',
    'PsychoPass': 'Psycho-Pass',
    'RapFrModern': 'Rap Francés Moderno',
    'RapUsModern': 'Rap Estadounidense Moderno',
    'RetourVersLeFutur': 'Regreso al Futuro',
    'RevolutionAndEmpire': 'Revolución e Imperio',
    'RollandGarros': 'Roland Garros',
    'SavoirFaireTraditional': 'Saber Hacer Tradicional',
    'ScientificDiscovery': 'Descubrimientos Científicos',
    eula: 'Términos de Uso',
    eulaTitle: 'Términos de Uso de Quizzer',
    eulaIntro: 'Bienvenido a Quizzer. Al utilizar nuestra aplicación, usted acepta estos términos de uso.',
    eulaSection1Title: '1. Aceptación de los Términos',
    eulaSection1Content: 'Al acceder a la aplicación Quizzer, usted acepta quedar vinculado por estos términos de uso, todas las leyes y regulaciones aplicables, y acepta que es responsable del cumplimiento de cualquier ley local aplicable.',
    eulaSection2Title: '2. Licencia de Uso',
    eulaSection2Content: 'Se otorga permiso para descargar temporalmente una copia de la aplicación Quizzer únicamente para visualización personal y no comercial.',
    eulaSection3Title: '3. Propiedad Intelectual',
    eulaSection3Content: 'Todo el contenido presente en la aplicación Quizzer es propiedad de Quizzer o de sus proveedores de contenido y está protegido por las leyes de propiedad intelectual.',
    eulaSection4Title: '4. Uso de Datos',
    eulaSection4Content: 'Quizzer recopila y utiliza sus datos de acuerdo con nuestra Política de Privacidad.',
    eulaSection5Title: '5. Modificaciones',
    eulaSection5Content: 'Quizzer puede revisar estos términos de uso en cualquier momento sin previo aviso.',
    privacySection1: '1. Introducción',
    privacySection1Text: 'Bienvenido a nuestra Política de Privacidad. Quizzer respeta su privacidad y se compromete a proteger sus datos personales. Esta política de privacidad le informará sobre cómo cuidamos sus datos personales cuando visita nuestra aplicación y le informará sobre sus derechos de privacidad y cómo la ley le protege.',
    privacySection2: '2. Los Datos que Recopilamos',
    privacySection2Text: 'Podemos recopilar, usar, almacenar y transferir diferentes tipos de datos personales sobre usted, incluyendo:\n\n• Datos de Identidad: nombre, apellido, nombre de usuario o identificador similar\n• Datos de Contacto: dirección de correo electrónico\n• Datos de Uso: información sobre cómo utiliza nuestra aplicación',
    privacySection3: '3. Cómo Usamos sus Datos',
    privacySection3Text: 'Utilizamos sus datos para los siguientes propósitos:\n\n• Para gestionar su cuenta y proporcionarle nuestros servicios\n• Para mejorar nuestra aplicación y mantener su seguridad\n• Para proporcionarle funciones personalizadas y recomendaciones basadas en sus preferencias\n• Para enviarle notificaciones y actualizaciones sobre su actividad',
    privacySection4: '4. Seguridad de los Datos',
    privacySection4Text: 'Hemos implementado medidas de seguridad apropiadas para evitar que sus datos personales se pierdan accidentalmente, se utilicen o accedan de manera no autorizada, se alteren o se divulguen.',
    privacySection5: '5. Conservación de Datos',
    privacySection5Text: 'Solo conservaremos sus datos personales durante el tiempo necesario para cumplir los propósitos para los que los recopilamos, incluyendo requisitos legales, contables o de informes.',
    privacySection6: '6. Sus Derechos Legales',
    privacySection6Text: 'Según las leyes aplicables de protección de datos, puede tener derechos sobre sus datos personales, incluyendo el derecho de acceso, rectificación, eliminación, oposición al procesamiento, restricción del procesamiento, portabilidad de datos y retirada del consentimiento.',
    privacySection7: '7. Cambios en Nuestra Política de Privacidad',
    privacySection7Text: 'Publicaremos cualquier cambio en nuestra política de privacidad en esta página. Si los cambios son significativos, le notificaremos por correo electrónico o mediante una notificación en la aplicación.',
    privacySection8: '8. Contacto',
    privacySection8Text: 'Si tiene alguna pregunta sobre esta política de privacidad o desea ejercer alguno de sus derechos legales, contáctenos a través de nuestra página de contacto.',
    lastUpdated: 'Última actualización',
    allRightsReserved: 'Todos los derechos reservados'
  }
};

// Provider du contexte
export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('fr');

  const changeLanguage = (code) => {
    setCurrentLanguage(code);
  };

  const t = (key) => {
    if (!key || typeof key !== 'string') return '';
    
    if (languages[currentLanguage] && typeof languages[currentLanguage][key] !== 'undefined') {
      const translation = languages[currentLanguage][key];
      // Assurer que la traduction est une chaîne
      return typeof translation === 'string' ? translation : String(translation || '');
    }
    // Fallback: retourner la clé ou chaîne vide
    return key || '';
  };

  return (
    <LanguageContext.Provider 
      value={{ 
        currentLanguage, 
        changeLanguage, 
        t, 
        languages,
        currentLangData: languages[currentLanguage]
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte
export const useLanguage = () => useContext(LanguageContext);

export default LanguageContext; 